export enum IncomingActions {
    Loaded = 'LOADED',
    ROUTING = 'ROUTING',
}
